import React, { useState } from "react"
import { Home, User, Settings, BookOpen, Menu, X } from "lucide-react"

const Sidebar = ({ activeTab, handleTabClick }) => {
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

	return (
		<>
			{/* Mobile Menu Button - only visible on small screens */}
			<div className="md:hidden fixed top-4 left-4 z-30">
				<button 
					onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
					className="bg-[#1E1E1E] p-2 rounded-lg text-[#FF3A6E]"
				>
					{mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
				</button>
			</div>
			
			{/* Mobile Sidebar - fullscreen overlay on small screens */}
			<div className={`md:hidden fixed inset-0 bg-[#121212] z-20 transition-transform duration-300 ease-in-out ${
				mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
			}`}>
				<div className='flex flex-col items-center pt-16 pb-6 h-full'>
					<div 
						className='text-orange-500 font-bold text-2xl mb-8 cursor-pointer hover:text-orange-400 transition-colors'
						onClick={() => {
							handleTabClick("home");
							setMobileMenuOpen(false);
						}}
					>
						HedgeHop
					</div>
					<nav className='space-y-6 flex-1 w-full px-6'>
						<div
							className={`p-4 ${
								activeTab === "home" ? "bg-[#2C2C2C]" : "hover:bg-[#2C2C2C]"
							} rounded-lg cursor-pointer flex items-center`}
							onClick={() => {
								handleTabClick("home");
								setMobileMenuOpen(false);
							}}>
							<Home
								className={activeTab === "home" ? "text-white" : "text-[#6E6E6E]"}
								size={24}
							/>
							<span 
								className={`ml-3 font-medium text-lg ${
									activeTab === "home" ? "text-white" : "text-[#6E6E6E]"
								}`}>
								Home
							</span>
						</div>
						<div
							className={`p-4 ${
								activeTab === "learn" ? "bg-[#2C2C2C]" : "hover:bg-[#2C2C2C]"
							} rounded-lg cursor-pointer flex items-center`}
							onClick={() => {
								handleTabClick("learn");
								setMobileMenuOpen(false);
							}}>
							<BookOpen
								className={activeTab === "learn" ? "text-white" : "text-[#6E6E6E]"}
								size={24}
							/>
							<span 
								className={`ml-3 font-medium text-lg ${
									activeTab === "learn" ? "text-white" : "text-[#6E6E6E]"
								}`}>
								Learn
							</span>
						</div>
						<div
							className={`p-4 ${
								activeTab === "profile" ? "bg-[#2C2C2C]" : "hover:bg-[#2C2C2C]"
							} rounded-lg cursor-pointer flex items-center`}
							onClick={() => {
								handleTabClick("profile");
								setMobileMenuOpen(false);
							}}>
							<User
								className={
									activeTab === "profile" ? "text-white" : "text-[#6E6E6E]"
								}
								size={24}
							/>
							<span 
								className={`ml-3 font-medium text-lg ${
									activeTab === "profile" ? "text-white" : "text-[#6E6E6E]"
								}`}>
								Profile
							</span>
						</div>
						<div
							className={`p-4 ${
								activeTab === "settings" ? "bg-[#2C2C2C]" : "hover:bg-[#2C2C2C]"
							} rounded-lg cursor-pointer flex items-center`}
							onClick={() => {
								handleTabClick("settings");
								setMobileMenuOpen(false);
							}}>
							<Settings
								className={
									activeTab === "settings" ? "text-white" : "text-[#6E6E6E]"
								}
								size={24}
							/>
							<span 
								className={`ml-3 font-medium text-lg ${
									activeTab === "settings" ? "text-white" : "text-[#6E6E6E]"
								}`}>
								Settings
							</span>
						</div>
					</nav>
				</div>
			</div>
			
			{/* Desktop Sidebar - visible on medium and larger screens */}
			<div className='hidden md:flex w-48 bg-[#1E1E1E] flex-col py-6'>
				<div 
					className='text-orange-500 font-bold text-lg text-center mb-8 cursor-pointer hover:text-orange-400 transition-colors'
					onClick={() => handleTabClick("home")}
				>
					HedgeHop
				</div>
				<nav className='space-y-2 px-3'>
					<div
						className={`p-3 ${
							activeTab === "home" ? "bg-[#2C2C2C]" : "hover:bg-[#2C2C2C]"
						} rounded-lg cursor-pointer flex items-center`}
						onClick={() => handleTabClick("home")}>
						<Home
							className={activeTab === "home" ? "text-white" : "text-[#6E6E6E]"}
							size={20}
						/>
						<span 
							className={`ml-3 font-medium ${
								activeTab === "home" ? "text-white" : "text-[#6E6E6E]"
							}`}>
							Home
						</span>
					</div>
					<div
						className={`p-3 ${
							activeTab === "learn" ? "bg-[#2C2C2C]" : "hover:bg-[#2C2C2C]"
						} rounded-lg cursor-pointer flex items-center`}
						onClick={() => handleTabClick("learn")}>
						<BookOpen
							className={activeTab === "learn" ? "text-white" : "text-[#6E6E6E]"}
							size={20}
						/>
						<span 
							className={`ml-3 font-medium ${
								activeTab === "learn" ? "text-white" : "text-[#6E6E6E]"
							}`}>
							Learn
						</span>
					</div>
					<div
						className={`p-3 ${
							activeTab === "profile" ? "bg-[#2C2C2C]" : "hover:bg-[#2C2C2C]"
						} rounded-lg cursor-pointer flex items-center`}
						onClick={() => handleTabClick("profile")}>
						<User
							className={
								activeTab === "profile" ? "text-white" : "text-[#6E6E6E]"
							}
							size={20}
						/>
						<span 
							className={`ml-3 font-medium ${
								activeTab === "profile" ? "text-white" : "text-[#6E6E6E]"
							}`}>
							Profile
						</span>
					</div>
					<div
						className={`p-3 ${
							activeTab === "settings" ? "bg-[#2C2C2C]" : "hover:bg-[#2C2C2C]"
						} rounded-lg cursor-pointer flex items-center`}
						onClick={() => handleTabClick("settings")}>
						<Settings
							className={
								activeTab === "settings" ? "text-white" : "text-[#6E6E6E]"
							}
							size={20}
						/>
						<span 
							className={`ml-3 font-medium ${
								activeTab === "settings" ? "text-white" : "text-[#6E6E6E]"
							}`}>
							Settings
						</span>
					</div>
				</nav>
			</div>
		</>
	)
}

export default Sidebar